import React, { useEffect } from 'react';
import { Breadcrumb, Button, Icon, Menu, Popup } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/actions';
import * as selectors from '../../../../redux/selectors';
import * as api from '../../../../api/showcaseApi';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import PageContainer from '../../../common/PageContainer';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import AdSlotPageInformation from './AdSlotPageInformation';
import AdSlotPageItems from './AdSlotPageItems';
import { adSlotInitialValues, adSlotValidationSchema } from '../../adslot.constants';
import AddListingModal from '../../listings/AddListingModal';

const EditAdSlotPage = ({ match, currentAdSlot, getAdSlotById, updateAdSlot, createAdSlot, history, isGowUser }) => {
  const id = match.params.id;

  useEffect(() => getAdSlotById(id), [id]);

  const handleSubmit = adSlot => (adSlot.id ? updateAdSlot(adSlot) : createAdSlot(adSlot));

  const getPage = () => (
    <PageContainer>
      <Formik
        onSubmit={handleSubmit}
        initialValues={{ ...adSlotInitialValues, ...currentAdSlot }}
        validationSchema={adSlotValidationSchema}
        enableReinitialize
      >
        {formik => (
          <>
            <Breadcrumb>
              <Breadcrumb.Section>
                <Link to="/ad-slot">Ad Slots</Link>
              </Breadcrumb.Section>
              <Breadcrumb.Divider icon="chevron right" />
              <Breadcrumb.Section>Edit Slot</Breadcrumb.Section>
            </Breadcrumb>
            <Menu borderless attached="top">
              <Menu.Item header>
                <Icon name="list alternate outline" />
                Ad slot
              </Menu.Item>
            </Menu>

            <AdSlotPageInformation currentAdSlot={currentAdSlot} formik={formik} />
            <AdSlotPageItems currentAdSlot={currentAdSlot} formik={formik} />

            <br />

            <Button
              icon="save"
              disabled={!formik.isValid}
              positive
              content="Save changes"
              onClick={() => {
                formik.submitForm().then(() => {
                  history.push(`/ad-slot`);
                });
              }}
            />

            <Button
              icon="save"
              disabled={!formik.isValid}
              positive
              content="Save as new"
              onClick={() => {
                formik.submitForm().then(() => {
                  api.cloneAdSlotById(currentAdSlot.id).then(newAdSlot => {
                    history.push(`/ad-slot/${newAdSlot.id}`);
                  });
                });
              }}
            />

            <Button
              content="Preview"
              icon="binoculars"
              as="a"
              href={`${currentAdSlot?.sites[0]?.site?.apiUrl?.replace('/api', '')}/preview?showcase_id=${
                currentAdSlot.id
              }&displayType=desktop`}
              target="_blank"
            />

            <AddListingModal />

            {isGowUser && (
              <Popup
                closeOnPortalMouseLeave
                trigger={<Button content="Delete" labelPosition="left" negative floated="right" icon="trash" />}
                content={
                  <Button
                    color="green"
                    content="Are you sure?"
                    onClick={() => {
                      formik.setFieldValue('isDeleted', true);
                      formik.submitForm().then(() => {
                        history.push('/ad-slot');
                      });
                    }}
                  />
                }
                on="click"
                position="bottom left"
              />
            )}
          </>
        )}
      </Formik>
    </PageContainer>
  );

  return <>{currentAdSlot && currentAdSlot.id && getPage()}</>;
};

const mapStateToProps = state => ({
  currentAdSlot: selectors.getCurrentAdSlot(state),
  isGowUser: selectors.users.isGowUser(state),
});

const mapDispatchToProps = dispatch => ({
  getAdSlotById: bindActionCreators(actions.adSlot.getAdSlotById, dispatch),
  createAdSlot: bindActionCreators(actions.adSlot.addAdSlot, dispatch),
  updateAdSlot: bindActionCreators(actions.adSlot.updateAdSlot, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditAdSlotPage));
